var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnectedUnassignedDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-1058 -100)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1039 42C42.0976 42 42.9032 40.8748 42.9032 39.4868C42.9032 38.0988 42.0976 36.9736 41.1039 36.9736C40.1102 36.9736 39.3047 38.0988 39.3047 39.4868C39.3047 40.8748 40.1102 42 41.1039 42Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.025 42C33.8238 42 33.6225 41.9008 33.4687 41.7024C33.2319 41.4048 33.1846 41.0576 33.1846 40.8096C33.1846 40.5119 33.2556 40.2474 33.3976 40.0325L49.0345 15.3968C49.2002 15.1488 49.4369 15 49.6737 15C49.8749 15 50.0761 15.0992 50.23 15.2976C50.5851 15.7275 50.6206 16.4715 50.301 16.9841L34.6642 41.5866C34.4985 41.8512 34.2736 41.9835 34.025 41.9835V42Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1224 34.3447C45.0571 32.8567 43.7077 31.9142 42.2398 31.6001L41.0088 33.5346C42.4884 33.5015 43.9681 34.2621 45.0926 35.8328C45.2228 36.0312 45.4122 36.1304 45.6134 36.1304C45.8147 36.1304 45.9922 36.0147 46.1343 35.8328V35.7997C46.4184 35.4029 46.4184 34.7746 46.1343 34.3778H46.1224V34.3447Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7468 31.1867H32.7705V31.2033C33.0546 31.5835 33.5044 31.567 33.7885 31.1867V31.1537C35.6469 28.5909 38.0025 27.2186 40.4054 27.0036L41.7075 24.9534C41.5063 24.9534 41.305 24.9038 41.092 24.9038C37.9551 24.9038 35.0077 26.5903 32.7823 29.6656H32.7705C32.7705 29.6656 32.7468 29.7152 32.7468 29.7317L32.6994 29.7979C32.4509 30.1947 32.4627 30.8064 32.735 31.1867H32.7468Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4486 29.698C48.3477 28.1769 47.0693 26.9864 45.6844 26.1763L44.6309 27.8297C46.0158 28.5241 47.3179 29.6319 48.4187 31.1861C48.5489 31.3845 48.7383 31.4837 48.9396 31.4837C49.1408 31.4837 49.3184 31.3679 49.4604 31.1861V31.153C49.7445 30.7562 49.7445 30.1279 49.4604 29.7311H49.4486V29.698Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7871 25.0862H52.7634V25.0697C51.5915 23.4493 50.3013 22.1266 48.9163 21.085L47.9102 22.6722C49.2951 23.6477 50.5853 24.9374 51.7454 26.5412C51.8874 26.7396 52.065 26.8388 52.2662 26.8388C52.4674 26.8388 52.6332 26.7396 52.7634 26.5577H52.7871C53.0711 26.1278 53.0711 25.483 52.7871 25.0862Z",
    fill: "#CA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2882 20.886L45.3891 19.15C39.873 17.0832 33.7413 19.0508 29.4208 25.0857L29.2432 25.5156C29.1604 25.8793 29.2432 26.2761 29.4208 26.5407H29.4445V26.5572C29.7285 26.9375 30.1784 26.921 30.4624 26.5407C34.2148 21.3159 39.4587 19.4311 44.2882 20.886Z",
    fill: "#CA0000"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1027,
    y: -20,
    width: 1521,
    height: 91,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2486 38.0002C27.4808 38.0002 28.4797 36.9584 28.4797 35.6732C28.4797 34.388 27.4808 33.3462 26.2486 33.3462C25.0165 33.3462 24.0176 34.388 24.0176 35.6732C24.0176 36.9584 25.0165 38.0002 26.2486 38.0002Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4709 38C17.2213 38 16.9718 37.9081 16.781 37.7244C16.4874 37.4489 16.4287 37.1274 16.4287 36.8977C16.4287 36.6222 16.5168 36.3772 16.6929 36.1782L36.0826 13.3674C36.2881 13.1378 36.5816 13 36.8752 13C37.1247 13 37.3743 13.0919 37.5651 13.2756C38.0054 13.6736 38.0494 14.3625 37.6531 14.8371L18.2635 37.6173C18.058 37.8622 17.7791 37.9847 17.4709 37.9847V38Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4718 30.9119C31.1507 29.5341 29.4775 28.6615 27.6574 28.3706L26.1309 30.1618C27.9656 30.1312 29.8004 30.8354 31.1948 32.2898C31.3562 32.4735 31.5911 32.5653 31.8406 32.5653C32.0901 32.5653 32.3103 32.4582 32.4864 32.2898V32.2592C32.8387 31.8917 32.8387 31.31 32.4864 30.9426H32.4718V30.9119Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8858 27.9879H15.9152V28.0032C16.2675 28.3553 16.8252 28.34 17.1775 27.9879V27.9573C19.4819 25.5844 22.4029 24.3137 25.3825 24.1147L26.9971 22.2163C26.7476 22.2163 26.498 22.1704 26.2338 22.1704C22.3442 22.1704 18.6893 23.732 15.9299 26.5795H15.9152C15.9152 26.5795 15.8858 26.6254 15.8858 26.6407L15.8271 26.7019C15.5189 27.0694 15.5336 27.6358 15.8712 27.9879H15.8858Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.597 26.6095C35.2319 25.2011 33.6467 24.0988 31.9294 23.3486L30.623 24.8796C32.3404 25.5225 33.955 26.5483 35.32 27.9873C35.4815 28.171 35.7163 28.2629 35.9659 28.2629C36.2154 28.2629 36.4355 28.1557 36.6117 27.9873V27.9567C36.964 27.5893 36.964 27.0075 36.6117 26.6401H36.597V26.6095Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7358 22.3396H40.7065V22.3243C39.2533 20.824 37.6534 19.5992 35.9361 18.6348L34.6885 20.1045C36.4058 21.0077 38.0057 22.2018 39.4442 23.6868C39.6203 23.8705 39.8405 23.9624 40.09 23.9624C40.3395 23.9624 40.545 23.8705 40.7065 23.7021H40.7358C41.0881 23.3041 41.0881 22.707 40.7358 22.3396V22.3396Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1968 18.4501L31.5618 16.8427C24.7219 14.929 17.1187 16.7508 11.7612 22.3387L11.541 22.7367C11.4383 23.0735 11.541 23.4409 11.7612 23.6859H11.7905V23.7012C12.1428 24.0533 12.7006 24.038 13.0528 23.6859C17.7058 18.8482 24.2081 17.1029 30.1968 18.4501V18.4501Z",
    fill: "#252525"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -1029,
    y: -20,
    width: 1525,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-1058 -100)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    fill: "white",
    transform: "translate(28 15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 25,
    fill: "white",
    transform: "translate(10 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedUnassignedDevices);
export default __webpack_public_path__ + "static/media/disconnected-unassigned-devices.3b74ce73543ce8b38e0c79310081eca5.svg";
export { ForwardRef as ReactComponent };